import { Helmet } from 'react-helmet-async';
import { SITE } from '../../config/site';
import { DEFAULT_KEYWORDS, absoluteUrl } from '../../config/seo';
import { mediaUrl } from '../../utils/mediaUrl';

function resolveImage(image) {
  if (!image) return absoluteUrl(SITE.defaultOgImage);
  if (image.startsWith('http')) return image;
  if (image.startsWith('/media/')) return mediaUrl(image);
  return absoluteUrl(image);
}

export function Seo({
  title,
  description = SITE.description,
  path = '/',
  image,
  keywords = DEFAULT_KEYWORDS,
  type = 'website',
  noindex = false,
  jsonLd,
}) {
  const fullTitle = title.includes(SITE.name) ? title : `${title} | ${SITE.name}`;
  const canonical = absoluteUrl(path.split('?')[0] || '/');
  const ogImage = resolveImage(image);
  const schemas = (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).filter(Boolean);

  return (
    <Helmet>
      <html lang="ru" />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta
        name="robots"
        content={noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large'}
      />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content={type} />
      <meta property="og:locale" content="ru_RU" />
      <meta property="og:site_name" content={SITE.brandName} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      <meta name="geo.region" content="RU-VGG" />
      <meta name="geo.placename" content={SITE.city} />
      <meta name="geo.position" content={`${SITE.geo.latitude};${SITE.geo.longitude}`} />
      <meta name="ICBM" content={`${SITE.geo.latitude}, ${SITE.geo.longitude}`} />

      {schemas.map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
